import { SettingsEndpoint } from '@constants/ApiEndpoints';
import {
  SETTINGS_USER_CHANGE_PASSWORD,
  SETTINGS_USER_CHANGE_PIN,
  SETTINGS_USER_CHECK_PIN,
  SETTINGS_USER_SET_INACTIVE,
} from '@constants/ApiEndpoints/SettingsEndpoint';
import { AxiosInstance } from 'axios';
import { ChangePasswordModel, ChangePinModel, UserModel } from 'models/Settings/Acl/userModel';
import { FetchingRequestParamsModels } from 'models/Shared/FetchingRequestParamsModels';
import { sprintf } from 'sprintf-js';

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<UserModel> => {
    return await axios.delete(`${SettingsEndpoint.SETTINGS_USER}/${id}`);
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<{
    items: UserModel[];
    total: number;
  }> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_USER, {
        params,
      })
      .then(({ data }) => data);
  };

export const getAllUsersByHotel =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<
    Array<{
      id: number;
      name: string;
    }>
  > => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_USER_BY_HOTEL, {
        params,
      })
      .then(({ data }) => data);
  };

export const getById =
  (axios: AxiosInstance) =>
  async (id?: number): Promise<UserModel> => {
    return await axios.get(`/${SettingsEndpoint.SETTINGS_USER}/${id}`).then(({ data }) => data);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: UserModel): Promise<UserModel> => {
    return await axios.post(SettingsEndpoint.SETTINGS_USER, data).then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: UserModel): Promise<UserModel> => {
    return await axios
      .put(`/${SettingsEndpoint.SETTINGS_USER}/${data.id}`, data)
      .then(({ data }) => data);
  };

export const updatePassword =
  (axios: AxiosInstance) =>
  async (data: ChangePasswordModel): Promise<UserModel> => {
    return await axios.patch(sprintf(SETTINGS_USER_CHANGE_PASSWORD), data).then(({ data }) => data);
  };

export const updatePin =
  (axios: AxiosInstance) =>
  async (data: ChangePinModel): Promise<{ success: boolean }> => {
    return await axios.patch(sprintf(SETTINGS_USER_CHANGE_PIN), data).then(({ data }) => data);
  };

export const checkUserPin =
  (axios: AxiosInstance) =>
  async (data: ChangePinModel): Promise<{ success: boolean; message: string }> => {
    return await axios.post(sprintf(SETTINGS_USER_CHECK_PIN), data).then(({ data }) => data);
  };

export const setUserInactive =
  (axios: AxiosInstance) => async (): Promise<{ success: boolean }> => {
    return await axios.post(sprintf(SETTINGS_USER_SET_INACTIVE), {}).then(({ data }) => {
      return data;
    });
  };
